<div class="entry-exit-container">
  <h1 class="page-title">人員進出廠區管理</h1>

  <!-- 過濾區域 -->
  <div class="filter-panel">
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <label>日期區間：</label>
          <div class="date-range-picker">
            <input type="date" class="form-control" [(ngModel)]="dateFilterStart" (change)="applyFilters()">
            <span class="date-separator">至</span>
            <input type="date" class="form-control" [(ngModel)]="dateFilterEnd" (change)="applyFilters()">
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>人員狀態：</label>
          <select class="form-control" [(ngModel)]="statusFilter" (change)="applyFilters()">
            <option value="all">全部</option>
            <option value="waiting">尚未進廠</option>
            <option value="entered">已進廠</option>
            <option value="exited">已離場</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>公司/承攬商：</label>
          <select class="form-control" [(ngModel)]="contractorFilter" (change)="applyFilters()">
            <option value="">全部</option>
            <option *ngFor="let contractor of contractors" [value]="contractor.id">{{contractor.name}}</option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>關鍵字搜尋：</label>
          <div class="search-input">
            <input type="text" class="form-control" placeholder="姓名、身份證號、工種..." [(ngModel)]="searchText" (input)="applyFilters()">
            <span class="clear-search" *ngIf="searchText" (click)="clearSearch()">×</span>
          </div>
        </div>
      </div>
    </div>
    <div class="filter-actions">
      <button class="btn btn-secondary" (click)="resetFilters()">重置篩選</button>
      <button class="btn btn-primary" (click)="openQrScanner()">
        <i class="fas fa-qrcode"></i> 開啟 QR Code 掃描
      </button>
    </div>
  </div>

  <!-- 人員列表 -->
  <div class="personnel-list-panel">
    <div class="panel-header">
      <h2>進出場人員清單</h2>
      <div class="panel-actions">
        <span class="personnel-count">共 {{filteredPersonnel.length}} 人</span>
      </div>
    </div>
    <div class="panel-content">
      <div class="table-responsive">
        <table class="data-table">
          <thead>
            <tr>
              <th>照片</th>
              <th>姓名</th>
              <th>身份證號</th>
              <th>公司/承攬商</th>
              <th>工種</th>
              <th>施工申請單號</th>
              <th>預計進廠時間</th>
              <th>進廠時間</th>
              <th>離場時間</th>
              <th>狀態</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let person of filteredPersonnel" [ngClass]="getRowClass(person)">
              <td class="photo-cell">
                <img [src]="person.photoUrl || 'assets/images/JSAI/250402-JS-mascot.png'" alt="照片" class="personnel-photo">
              </td>
              <td>{{person.name}}</td>
              <td>{{person.idNumber}}</td>
              <td>{{person.contractor.name}}</td>
              <td>{{person.jobType}}</td>
              <td>{{person.applicationId}}</td>
              <td>{{person.scheduledEntryTime | date:'yyyy-MM-dd HH:mm'}}</td>
              <td>{{person.entryTime ? (person.entryTime | date:'yyyy-MM-dd HH:mm') : '-'}}</td>
              <td>{{person.exitTime ? (person.exitTime | date:'yyyy-MM-dd HH:mm') : '-'}}</td>
              <td>
                <span class="status-badge" [ngClass]="'status-' + person.status">
                  {{getStatusText(person.status)}}
                </span>
              </td>
              <td class="actions-cell">
                <button class="btn btn-sm btn-success" *ngIf="canRecordEntry(person)" (click)="recordEntry(person)">
                  登記進廠
                </button>
                <button class="btn btn-sm btn-warning" *ngIf="canRecordExit(person)" (click)="recordExit(person)">
                  登記離場
                </button>
                <button class="btn btn-sm btn-info" (click)="viewDetails(person)">
                  <i class="fas fa-info-circle"></i>
                </button>
              </td>
            </tr>
            <tr *ngIf="filteredPersonnel.length === 0">
              <td colspan="11" class="no-data">沒有符合條件的人員紀錄</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- 分頁控制 -->
      <div class="pagination-controls" *ngIf="totalItems > itemsPerPage">
        <ul class="pagination">
          <li [class.disabled]="currentPage === 1">
            <a (click)="changePage(1)">首頁</a>
          </li>
          <li [class.disabled]="currentPage === 1">
            <a (click)="changePage(currentPage - 1)">上一頁</a>
          </li>
          <li *ngFor="let page of pageNumbers" [class.active]="page === currentPage">
            <a (click)="changePage(page)">{{page}}</a>
          </li>
          <li [class.disabled]="currentPage === totalPages">
            <a (click)="changePage(currentPage + 1)">下一頁</a>
          </li>
          <li [class.disabled]="currentPage === totalPages">
            <a (click)="changePage(totalPages)">末頁</a>
          </li>
        </ul>
        <div class="pagination-info">
          顯示 {{(currentPage - 1) * itemsPerPage + 1}} - {{getCurrentPageLastItem()}} 筆，共 {{totalItems}} 筆
        </div>
      </div>
    </div>
  </div>

  <!-- QR Code 掃描器模態框 -->
  <div class="modal fade" [class.show]="showQrScanner" *ngIf="showQrScanner">
    <div class="modal-backdrop" (click)="closeQrScanner()"></div>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>QR Code 進出場掃描</h5>
          <button type="button" class="close-btn" (click)="closeQrScanner()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="qr-scanner">
            <div class="video-container">
              <video #videoElement [hidden]="!scannerActive"></video>
              <canvas #canvasElement [hidden]="!scannerActive"></canvas>
              <div class="scanner-overlay" [hidden]="!scannerActive">
                <div class="scanner-target"></div>
              </div>
              <div class="scanner-prompt" *ngIf="scannerActive">
                請將工作人員的 QR Code 放入掃描框中
              </div>
              <div class="scan-result" *ngIf="lastScannedPerson">
                <div class="result-header" [ngClass]="'result-' + lastScanAction">
                  <span *ngIf="lastScanAction === 'entry'">進廠登記成功</span>
                  <span *ngIf="lastScanAction === 'exit'">離場登記成功</span>
                </div>
                <div class="result-content">
                  <!-- <img [src]="lastScannedPerson.photoUrl || 'assets/images/JSAI/250402-JS-mascot.png'" alt="照片" class="result-photo"> -->
                  <img src="assets/images/JSAI/250402-JS-mascot.png"  alt="照片" class="result-photo">

                  <div class="result-info">
                    <h4>{{lastScannedPerson.name}}</h4>
                    <p>{{lastScannedPerson.contractor.name}}</p>
                    <p>身份證號: {{lastScannedPerson.idNumber}}</p>
                    <p>工種: {{lastScannedPerson.jobType}}</p>
                    <p *ngIf="lastScanAction === 'entry'">
                      進廠時間: {{lastScannedPerson.entryTime | date:'yyyy-MM-dd HH:mm:ss'}}
                    </p>
                    <p *ngIf="lastScanAction === 'exit'">
                      離場時間: {{lastScannedPerson.exitTime | date:'yyyy-MM-dd HH:mm:ss'}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" *ngIf="!scannerActive" (click)="startScanner()">
            開始掃描
          </button>
          <button type="button" class="btn btn-danger" *ngIf="scannerActive" (click)="pauseScanner()">
            暫停掃描
          </button>
          <button type="button" class="btn btn-secondary" (click)="closeQrScanner()">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- 人員詳細資訊模態框 -->
  <div class="modal fade" [class.show]="selectedPerson" *ngIf="selectedPerson">
    <div class="modal-backdrop" (click)="closePersonDetails()"></div>
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5>人員詳細資訊</h5>
          <button type="button" class="close-btn" (click)="closePersonDetails()">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="person-details">
            <div class="person-photo">
              <img [src]="selectedPerson.photoUrl || 'assets/images/JSAI/250402-JS-mascot.png'" alt="照片">
            </div>
            <div class="person-info">
              <div class="info-row">
                <div class="info-label">姓名:</div>
                <div class="info-value">{{selectedPerson.name}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">身份證號:</div>
                <div class="info-value">{{selectedPerson.idNumber}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">承攬商:</div>
                <div class="info-value">{{selectedPerson.contractor.name}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">聯絡電話:</div>
                <div class="info-value">{{selectedPerson.phone}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">工種:</div>
                <div class="info-value">{{selectedPerson.jobType}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">申請單號:</div>
                <div class="info-value">{{selectedPerson.applicationId}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">預計進廠時間:</div>
                <div class="info-value">{{selectedPerson.scheduledEntryTime | date:'yyyy-MM-dd HH:mm'}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">進廠時間:</div>
                <div class="info-value">{{selectedPerson.entryTime ? (selectedPerson.entryTime | date:'yyyy-MM-dd HH:mm:ss') : '尚未進廠'}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">離場時間:</div>
                <div class="info-value">{{selectedPerson.exitTime ? (selectedPerson.exitTime | date:'yyyy-MM-dd HH:mm:ss') : '尚未離場'}}</div>
              </div>
              <div class="info-row">
                <div class="info-label">進出場狀態:</div>
                <div class="info-value">
                  <span class="status-badge" [ngClass]="'status-' + selectedPerson.status">
                    {{getStatusText(selectedPerson.status)}}
                  </span>
                </div>
              </div>
            </div>
            <div class="qr-code-display">
              <h6>個人 QR Code</h6>
              <img [src]="'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=' + selectedPerson.idNumber" alt="QR Code">
              <button class="btn btn-sm btn-primary" (click)="printQrCode()">
                <i class="fas fa-print"></i> 列印 QR Code
              </button>
            </div>
          </div>

          <!-- 進出紀錄表格 -->
          <div class="entry-exit-history">
            <h6>進出紀錄</h6>
            <div class="table-responsive">
              <table class="data-table">
                <thead>
                  <tr>
                    <th>日期</th>
                    <th>進廠時間</th>
                    <th>離場時間</th>
                    <th>停留時間</th>
                    <th>申請單號</th>
                    <th>登記人員</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let record of personEntryExitHistory">
                    <td>{{record.date | date:'yyyy-MM-dd'}}</td>
                    <td>{{record.entryTime | date:'HH:mm:ss'}}</td>
                    <td>{{record.exitTime ? (record.exitTime | date:'HH:mm:ss') : '-'}}</td>
                    <td>{{record.exitTime ? calculateDuration(record.entryTime, record.exitTime) : '尚未離場'}}</td>
                    <td>{{record.applicationId}}</td>
                    <td>{{record.registrar}}</td>
                  </tr>
                  <tr *ngIf="personEntryExitHistory.length === 0">
                    <td colspan="6" class="no-data">無進出紀錄</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-success" *ngIf="canRecordEntry(selectedPerson)" (click)="recordEntry(selectedPerson)">
            登記進廠
          </button>
          <button type="button" class="btn btn-warning" *ngIf="canRecordExit(selectedPerson)" (click)="recordExit(selectedPerson)">
            登記離場
          </button>
          <button type="button" class="btn btn-secondary" (click)="closePersonDetails()">
            關閉
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
